import { Avatar, Button, Text, Textarea } from '@mantine/core'
import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import DOMPurify from 'dompurify'
import { useCreatePostComment } from '../socials/api'
import { useArenaPost } from './api'
import classes from './Arena.module.css'
import AvatarMe from '../auth/AvatarMe'
import { useCompetitionId } from '../common/hooks'

export default function Comments({ post_id }: { post_id: number }) {
  const [comment, setComment] = useState<string>('')
  const queryClient = useQueryClient()
  const { mutate: createPostComment, isPending } = useCreatePostComment()
  const competitionId = useCompetitionId()

  const { data: arenaPost } = useArenaPost({
    competition_id: competitionId,
    post_id: post_id,
    should_load: true,
  })

  function handleAddPostComment() {
    createPostComment(
      {
        kind: 'post',
        post_id: post_id,
        text: comment,
      },
      {
        onSuccess: async () => {
          await queryClient.invalidateQueries({
            queryKey: [
              'arenaPost',
              { competition_id: competitionId, post_id: post_id },
            ],
          })
          setComment('')
        },
      }
    )
  }

  return (
    <div className={classes.createCommentWrapper}>
      <div className={classes.createCommentContainer}>
        <div className={classes.createCommentStatus}>
          <AvatarMe size="md" className={classes.postAuthorAvatar} />
          <Textarea
            classNames={{
              root: classes.textareaRoot,
              input: classes.commentTextarea,
            }}
            autosize
            placeholder="Write a comment"
            maxLength={280}
            value={comment}
            onChange={(event) => setComment(event.currentTarget.value)}
          />
        </div>
        <div className={classes.createCommentActions}>
          <Text component="p">{comment.length} / 280</Text>
          <Button
            loading={isPending}
            disabled={isPending || comment.length === 0}
            onClick={handleAddPostComment}
          >
            Comment
          </Button>
        </div>
      </div>
      {arenaPost &&
        arenaPost.comments.length > 0 &&
        arenaPost.comments.map((comment) => (
          <div
            className={classes.commentsContainer}
            key={comment.comment_id}
            id={`comment-${comment.comment_id}`}
          >
            <div className={classes.commentDetailsAuthor}>
              <div>
                <Avatar radius="xl" src={comment.user_photo} />
                <div className={classes.comment}>
                  <div className={classes.authorDateContainer}>
                    <p>{`${comment.user_first_name} ${comment.user_last_name}`}</p>
                    <p className={classes.date}>
                      {new Date(comment.created_at).toLocaleDateString('en-GB')}
                    </p>
                  </div>
                  <Text
                    className={classes.comment}
                    component="p"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(comment.text),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  )
}
